import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import DateTime from 'react-datetime';
import PropTypes from 'prop-types';

import 'react-datetime/css/react-datetime.css';
import { isMoment } from 'moment';

import { DATE_FORMAT, TIME_FORMAT, DATE_TIME_FORMAT } from '../common/dateTimeFormats';

export default class DateTimeFilter extends Component {
  constructor(props) {
    super(props);
    const { value } = this.props;
    this.state = {
      left: (value !== undefined && value !== null && value.left !== undefined) ? this.props.value.left : '',
      right: (value !== undefined && value !== null && value.right !== undefined) ? this.props.value.right : ''
    };
  }

  onLeftChange(val) {
    this.onChange(val, 'left');
  }

  onRightChange(val) {
    this.onChange(val, 'right');
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value === this.props.value) return false;
    const { value } = this.props;
    this.setState({
      left: (value && value.left) || '',
      right: (value && value.left) || '',
    });
  }

  onChange(val, stateKey) {
    let nval = '';
    if (isMoment(val) && val.isValid()) {
      nval = val.format(DATE_TIME_FORMAT);
    }

    let nstate = { [stateKey]: nval };
    const { left, right } = this.state;
    if (nval.length > 0) {
      if (stateKey === 'left' && right.length === 0) {
        val.add(1, 'day').add(-1, 'second');
        nstate.right = val.format(DATE_TIME_FORMAT);
      } else if (stateKey === 'right' && left.length === 0) {
        val.add(-1, 'day').add(1, 'second');
        nstate.left = val.format(DATE_TIME_FORMAT);
      }
    }
    this.setState({ ...nstate }, () => {
      this.props.onChange(this.state)
    });
  }

  render() {
    const { value } = this.props;
    return (
      <div onClick={this.props.onClick}>
        <Grid fluid className="noPadding">
          <Row className="noMargin">
            <Col lg={6} className="noPadding">
              <DateTime
                value={value && value.left}
                dateFormat={DATE_FORMAT}
                timeFormat={TIME_FORMAT}
                closeOnSelect={true}
                onChange={val => this.onLeftChange(val)}
                inputProps={{ onKeyPress: this.props.onKeyPress }}
              />
            </Col>
            <Col lg={6} className="noPadding">
              <DateTime
                value={value && value.right}
                dateFormat={DATE_FORMAT}
                timeFormat={TIME_FORMAT}
                closeOnSelect={true}
                onChange={val => this.onRightChange(val)}
                inputProps={{ onKeyPress: this.props.onKeyPress }}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

DateTimeFilter.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/dateTimeTableColumnFilter.js